import { api } from '@/lib/api'
import type {
  AdmissaoCompletaPayload,
  AdmissaoIntegracao,
  AdmissoesListResponse,
  AdmissaoPatchPayload,
} from './integracaoTypes'

export async function fetchAdmissoes(params: { busca?: string; status?: string } = {}) {
  const qs = new URLSearchParams()
  if (params.busca) qs.set('busca', params.busca)
  if (params.status) qs.set('status', params.status)
  const suffix = qs.toString() ? `?${qs}` : ''
  return api.get<AdmissoesListResponse>(`/dp/admissoes/${suffix}`)
}

export async function fetchAdmissao(id: string) {
  const res = await api.get<{ sucesso?: boolean; dados: AdmissaoIntegracao }>(
    `/dp/admissoes/${id}/`,
  )
  return res.dados
}

export async function createAdmissao(colaboradorId: string) {
  const res = await api.post<{ sucesso?: boolean; dados: AdmissaoIntegracao }>(
    '/dp/admissoes/',
    { colaborador_id: colaboradorId },
  )
  return res.dados
}

export async function createAdmissaoCompleta(payload: AdmissaoCompletaPayload) {
  const res = await api.post<{
    sucesso?: boolean
    dados: AdmissaoIntegracao
    colaborador_id?: string
    mensagem?: string
  }>('/dp/admissoes/', payload)
  return res
}

export async function patchAdmissao(id: string, payload: AdmissaoPatchPayload) {
  const res = await api.patch<{ sucesso?: boolean; dados: AdmissaoIntegracao }>(
    `/dp/admissoes/${id}/`,
    payload,
  )
  return res.dados
}

export async function sincronizarAdmissoes(dias = 90) {
  return api.post<{
    sucesso?: boolean
    criados: number
    restaurados?: number
    ids: string[]
    erros?: { colaborador_id?: string; erro?: string }[]
    mensagem?: string
  }>('/dp/admissoes/sincronizar/', { dias })
}
